import { Pagination } from '@mui/material';
import Stack from '@mui/material/Stack';
import { TablePagination } from '@mui/material';

function Paging({ setPage, page = 0 }) {
 
  const handleChangePage = (event, page) => {
		setPage(page);
	};
	
  return (
    <Stack
      direction="row"
      justifyContent="center"
      mt={10}
    >
	
	<TablePagination
	  component="div"
	  count={100}
	  page={page}
	  onPageChange={handleChangePage}
	  rowsPerPage={10}
	/>  
    </Stack>
  )
}

export default Paging;